import React, {useContext} from "react";
import DynamicTextField from "../Textfield/Textfield";
import DynamicSelectInput from "../Select-Input/SelectInput";
import ToggleSwitcher from "../Toggle-Switcher/ToggleSwitcher";
import DatePicker from "../Date-Picker/DatePicker";
import calendarIcon from "../../Assets/Images/calendarIcon.png";
import darkCalendarIcon from "../../Assets/Images/calendar-dark-Icon.png";
import { DynamicContext } from "../../Context/DynamicContext";
import { createPortal } from "react-dom";

function DynamicCandidateCustomField({
  entity_type,
  field_key,
  label,
  field_type,
  required,
  options,
  value,
  onChange,
  canEditToggleStyle = {},
  canCreateTextFieldLabelStyle = {},
  textfieldType,
}) {
    const {isDarkMode} = useContext(DynamicContext);
  if (
    field_type === "text" ||
    field_type === "integer" ||
    field_type === "decimal"
  ) {
    return (
      <DynamicTextField
        label={label}
        required={required}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={label}
        labelStyle={canCreateTextFieldLabelStyle}
        type={textfieldType}
      />
    );
  }

  if (field_type === "date") {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginBottom: "10px",
        }}
      >
        <label style={{ marginBottom: "10px" }}>
          {label}
          {required && <span style={{ color: "red" }}> *</span>}
        </label>
        <DatePicker
          width="96%"
          selectedDate={value ? new Date(value) : null}
          onDateChange={(date) => {
            onChange(
              date?.toISOString().split("T")[0]
            );
          }}
          enableArrows={false}
          icon={isDarkMode ? darkCalendarIcon : calendarIcon}
        />
      </div>
    );
  }

  if (field_type === "boolean") {
    return (
      <div style={{ marginBottom: "10px" }}>
        <ToggleSwitcher
          label={label}
          required={required}
          value={value}
          onChange={(_, checked) => onChange(checked)}
        />
      </div>
    );
  }

  if (field_type === "select") {
    return (
      <DynamicSelectInput
        label={label}
        labelStyle={{ marginBottom: "10px" }}
        required={required}
        options={(options || []).map((opt) => ({
          title: opt,
        }))}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    );
  }

  return null;
}

export default DynamicCandidateCustomField;
